import { ReactNode } from 'react';

import { classNames } from '@bytel/product-wall/helpers';
import {
    Alignable,
    Box,
    BoxContent,
    Button,
    ButtonVariant,
    Column,
    Columns,
    Justifiable,
    Price,
    PriceLevel,
    StickyPosition,
    Text,
    TextLevels,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

import { ClickEvent } from '@trilogy-ds/react/lib/events/OnClickEvent';

type StickyMenuProps = {
    title?: string;
    ctaLabel?: string;
    price?: number;
    onTicketValidate?: ClickEvent;
    isVisible: boolean;
    stickyPosition: StickyPosition;
    onlyMobile?: boolean;
    className?: string;
    children?: ReactNode;
};

export function StickyMenu({
    title,
    ctaLabel,
    price,
    onTicketValidate,
    isVisible,
    stickyPosition,
    onlyMobile = false,
    className = '',
    children,
}: StickyMenuProps) {
    return (
        <View
            className={classNames(
                'sticky-bar',
                className,
                onlyMobile ? 'is-hidden-tablet' : '',
                stickyPosition === 'TOP' ? 'sticky-top' : 'sticky-bottom',
                isVisible ? 'visible' : '',
            )}
        >
            <Box>
                <BoxContent>
                    {children ||
                        (onlyMobile ? (
                            <>
                                <View flexable justify={Justifiable.SPACE_BETWEEN} align={Alignable.ALIGNED_CENTER}>
                                    <Text
                                        typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                        numberOfLines={1}
                                        level={TextLevels.ONE}
                                    >
                                        {title}
                                    </Text>
                                    {price ? <Price level={PriceLevel.SIX} amount={price} period='mois' /> : null}
                                </View>
                                <Button onClick={onTicketValidate} variant={ButtonVariant.CONVERSION}>
                                    {ctaLabel}
                                </Button>
                            </>
                        ) : (
                            <Columns align={Alignable.ALIGNED_CENTER}>
                                <Column size={8}>
                                    <Columns verticalAlign={Alignable.ALIGNED_CENTER} align={Alignable.ALIGNED_CENTER}>
                                        <Column narrow>
                                            <Text
                                                marginless
                                                typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                                numberOfLines={1}
                                                level={TextLevels.ONE}
                                            >
                                                {title}
                                            </Text>
                                        </Column>
                                        <Column narrow>
                                            {price ? (
                                                <Price level={PriceLevel.SIX} amount={price} period='mois' />
                                            ) : null}
                                        </Column>
                                        <Column narrow>
                                            <Button onClick={onTicketValidate} variant={ButtonVariant.CONVERSION}>
                                                {ctaLabel}
                                            </Button>
                                        </Column>
                                    </Columns>
                                </Column>
                            </Columns>
                        ))}
                </BoxContent>
            </Box>
        </View>
    );
}
